import { Injectable } from '@angular/core';
import { MonitorStatus, EventsLog, dataMonitoring } from '../model/monitoring.model';
import 'parse';
import { RecursiveTemplateAstVisitor } from '@angular/compiler';
const parse: typeof Parse = require('parse');

@Injectable()
export class MonitoringService {

  constructor(
  ) {

  }

  monitorStatusList: MonitorStatus[]

  public getMonitorStatus(): Promise<MonitorStatus[]> {
    return new Promise((resolve, reject) => {
      if (this.monitorStatusList) resolve(this.monitorStatusList)
      else {
        const query = new parse.Query('MonitorStatus');
        query.include(['devicePtr', 'devicePtr.companyPtr'])
        try {
          query.find().then(foundObject => {
            let Array = foundObject.map<MonitorStatus>(o => new MonitorStatus(o))
            Array = Array.map<MonitorStatus>(monitor => {
              let tmp = this.getMonitorCritical(monitor)
              if (tmp.length > 0) {
                monitor.critical = tmp
              } else monitor.critical = undefined
              return monitor
            })
            this.monitorStatusList = Array
            console.log('monitoring', this.monitorStatusList);
            resolve(this.monitorStatusList)
          })
        } catch (e) {
          console.error(e);
          reject();
        }
      }
    })
  }

  private testMonitoring(name, data: dataMonitoring): string[] {
    let tmp = []
    if (data === undefined) return tmp
    if (data['2DCameras'])
      data['2DCameras'].forEach(cam => {
        if (cam.Status === 'DOWN') {
          tmp.push(`Error : ${name} camera 2d id:${cam.Id} is ${cam.Status} (temp: ${cam.Temperature}) (serial: ${cam.Serial})`)
        }
      })
    if (data['3DCameras'])
      data['3DCameras'].forEach(cam => {
        if (cam.Status === 'DOWN') {
          tmp.push(`Error : ${name} camera 3d id:${cam.Id} is ${cam.Status} (temp: ${cam.Temperature}) (serial: ${cam.Serial})`)
        }
      })

    if (data.ComDaemon && data.ComDaemon.Status === 'DOWN')
      tmp.push(`Error : ${name} ComDaemon is ${data.ComDaemon.Status}`)

    if (data.Sensors) {
      if (data.Sensors.Sensor1.Status === 'DOWN')
        tmp.push(`Error : ${name} Sensor1 is ${data.Sensors.Sensor1.Status}`)
      if (data.Sensors.Sensor2.Status === 'DOWN')
        tmp.push(`Error : ${name} Sensor2 is ${data.Sensors.Sensor2.Status}`)
    }
    return tmp
  }

  public getMonitorCritical(monitor: MonitorStatus): string[] {
    let tmp = []
    // critical here
    tmp = tmp.concat(this.testMonitoring('Master', monitor.masterMonitoring))
    tmp = tmp.concat(this.testMonitoring('Slave', monitor.slaveMonitoring))
    return tmp
  }

  public getEventsLogs(): Promise<any> {
    return new Promise((resolve, reject) => {
      const query = new parse.Query('EventsLog');
      query
        .notEqualTo('isDeleted', true)
        .limit(500)
        .descending('createdAt')
        .find()
        .then(
          result => {
            let data = []
            result.forEach(log => {
              data.push(new EventsLog(log))
            });
            resolve(data);
          },
          error => {
            reject(error);
          }
        );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/service/monitoring.service.ts